import React from "react";
import { Link } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import { getDisplayName } from "../utils/displayName";

const BOOKING_URL = "https://www.roykensykkelservice.no/sykkelservice";
const SPOR_MEKANIKER_URL = "https://www.roykensykkelservice.no/chat";
const AKUTTSERVICE_URL = "https://www.roykensykkelservice.no/akutt";

function PlakatMekanikerchat() {
  return (
    <div className="min-h-screen bg-gray-100 py-8 print:bg-white print:py-0">
      <style>
        {`
@media print {
  @page { size: A4; margin: 0; }
  html, body { margin: 0 !important; padding: 0 !important; background: white !important; }
  * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  .plakat-no-print { display: none !important; }
}
`}
      </style>

      <div className="plakat-no-print max-w-3xl mx-auto mb-4 px-4 flex items-center justify-between">
        <Link to="/plakater" className="text-sm text-indigo-600 hover:text-indigo-800">
          ← Tilbake til plakater
        </Link>
        <button
          onClick={() => window.print()}
          className="px-4 py-2 rounded-md bg-indigo-600 text-white text-sm font-medium hover:bg-indigo-700"
        >
          Skriv ut plakat
        </button>
      </div>

      <div className="bg-white w-[210mm] h-[297mm] max-w-full mx-auto print:shadow-none shadow-lg flex flex-col overflow-hidden">
        {/* Topplinje: butikknavn + liten book service-QR */}
        <div className="flex items-center justify-between gap-6 px-10 pt-8 pb-6 border-b-4 border-red-600">
          <p className="text-2xl font-bold tracking-widest text-gray-900 uppercase">
            {getDisplayName()}
          </p>
          <div className="flex items-center gap-3 shrink-0 bg-blue-50 rounded-xl border border-blue-200 px-3 py-2">
            <QRCodeSVG value={BOOKING_URL} size={52} level="M" />
            <div className="text-left leading-tight">
              <p className="text-xs font-bold text-blue-800">Book service</p>
              <p className="text-[10px] text-gray-400">roykensykkelservice.no/sykkelservice</p>
            </div>
          </div>
        </div>

        {/* Seksjon 1: Spør mekaniker */}
        <div className="flex-1 flex flex-col items-center justify-center px-14 text-center border-b-2 border-dashed border-gray-200 bg-blue-50">
          <h1 className="text-4xl font-bold text-blue-800 mb-4">
            Mekaniker ikke til stede?
          </h1>
          <p className="text-2xl text-gray-700 mb-1">Spør mekaniker om hjelp og råd.</p>
          <p className="text-xl text-gray-500 mb-6">
            Skann QR-koden for å snakke med mekaniker her:
          </p>
          <div className="bg-white p-4 rounded-2xl border-4 border-blue-600">
            <QRCodeSVG value={SPOR_MEKANIKER_URL} size={220} level="M" />
          </div>
          <p className="text-sm text-gray-400 mt-4">roykensykkelservice.no/chat</p>
        </div>

        {/* Seksjon 2: Akuttservice */}
        <div className="flex-1 flex flex-col items-center justify-center px-14 text-center bg-red-50">
          <h1 className="text-4xl font-bold text-red-700 mb-4">Akuttservice</h1>
          <p className="text-2xl text-gray-700 mb-1">Har du akutt behov for hjelp?</p>
          <p className="text-xl text-gray-500 mb-6">
            Ta kontakt med mekaniker her:
          </p>
          <div className="bg-white p-4 rounded-2xl border-4 border-red-600">
            <QRCodeSVG value={AKUTTSERVICE_URL} size={220} level="M" />
          </div>
          <p className="text-sm text-gray-400 mt-4">roykensykkelservice.no/akutt</p>
        </div>
      </div>
    </div>
  );
}

export default PlakatMekanikerchat;
